import { useMemo } from 'react';

import { useUserStore } from '../../01-Users/store';
import { useWorkspaceStore } from '../../02-Workspaces/store';
import { deriveActiveWorkspaceMembers, deriveActiveWorkspaceUsers } from '../selectors';
import { useMemberStore } from '../store';

export const useActiveWorkspaceId = () => {
    const selectedWorkspaceId = useWorkspaceStore((state) => state.selectedWorkspace?.id);
    const userWorkspaceId = useUserStore((state) => state.selectedUser?.activeWorkspace?.id);

    return selectedWorkspaceId ?? userWorkspaceId;
};

export const useActiveWorkspaceMembers = () => {
    const members = useMemberStore((state) => state.members);
    const selectedMember = useMemberStore((state) => state.selectedMember);
    const workspaceId = useActiveWorkspaceId();

    return useMemo(
        () => deriveActiveWorkspaceMembers({ members, selectedMember, workspaceId }),
        [members, selectedMember, workspaceId],
    );
};

export const useActiveWorkspaceUsers = () => {
    const members = useMemberStore((state) => state.members);
    const selectedMember = useMemberStore((state) => state.selectedMember);
    const workspaceId = useActiveWorkspaceId();

    return useMemo(
        () => deriveActiveWorkspaceUsers({ members, selectedMember, workspaceId }),
        [members, selectedMember, workspaceId],
    );
};
